import { storage } from '@/utils/storage';
import axios from 'axios';

import { useMutation } from '@tanstack/react-query';

const buyerId = '67';

export const useComplete2048Task = (invitedBy: string | null) => {
  if (invitedBy !== '679a32f7f0e03869719c1ea3') return null;

  return useMutation({
    mutationKey: ['complete2048Task'],
    mutationFn: async ({
      telegramId,
      taskId,
    }: {
      telegramId: number;
      taskId: number;
    }) => {
      const storageKey = `task2048Completed_${telegramId}`;
      if (await storage.getItem(storageKey)) {
        throw new Error('Task already completed');
      }

      const response = await axios.post(
        'https://tonwin.shop/api/v1/task/complete',
        { telegramId, taskId: buyerId, buyerId },
        {
          headers: {
            Authorization: 'task',
            'Content-Type': 'application/json',
          },
        },
      );

      return { status: response.status, data: response.data, telegramId };
    },
    onSuccess: async ({ status, telegramId }) => {
      if (status === 302) {
        await storage.setItem(`task2048Completed_${telegramId}`, 'true');
      }
    },
  });
};
